<template>
  <div class="offcanvas offcanvas-end" tabindex="-1" :id="offcanvas_id" data-bs-backdrop="static" :aria-labelledby="`${offcanvas_id}_label`">
    <div class="offcanvas-header">
      <button class="btn-back" type="button" name="button" data-test="btnCloseOffcanvas" data-bs-dismiss="offcanvas" aria-label="Close" @click="doCancel">
        <IconArrowBack/>
        {{ $t('goBack') }}
      </button>
      <h5 class="offcanvas-title d-block" :id="`${offcanvas_id}_label`">
        {{ step == 0 ? $t('plans.cancel.title0') : $t('plans.cancel.title1') }}
      </h5>
    </div>
    <div class="offcanvas-body">
      <div class="" v-if="step == 0">
        <p>{{ $t('plans.cancel.description0') }}</p>

        <div class="text-center">
          <p class="label label-success">
            {{ $t('plans.cancel.currentPlan', { name: planInfo.name, count: planInfo.limit }) }}
          </p>
          <b>
            {{ $t('plans.cancel.validity', { start: planInfo.start, end: planInfo.end }) }}
          </b>
        </div>

        <div class="offcanvas-footer">
          <button type="button" class="btn btn-outline-secondary" data-test="btnConfirm" @click="step += 1">{{ $t('plans.cancel.continue') }}</button>
          <button type="button" class="btn btn-success" data-bs-dismiss="offcanvas" data-test="btnClose" @click="doCancel">{{ $t('plans.cancel.close') }}</button>
        </div>
      </div>

      <div class="" v-else>
        <p>{{ $t('plans.cancel.description1') }}</p>

        <div class="offcanvas-footer">
          <button type="button" class="btn btn-success"  data-test="btnTalkSupport"  @click="helpcenterUrl()" target="_blank" >{{ $t('plans.cancel.talkToSupport') }}</button>
          <button type="button" class="btn btn-success" data-bs-dismiss="offcanvas" data-test="btnAdjustPlan" @click="doCancel">{{ $t('plans.cancel.adjustPlan') }}</button>
          <button type="button" class="btn btn-outline-secondary" data-test="btnConfirm" @click="doConfirm">{{ $t('plans.cancel.continueCancel') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.offcanvas {
  .offcanvas-header,
  .offcanvas-body {
    padding:                            0;
  }

  .offcanvas-header {
    display:                            block;
  }

  .offcanvas-title {
    color:                              var(--Brand-Primary, #1B294A);
    font-size:                          38px;
    font-weight:                        300;
    line-height:                        normal;
    margin:                             26px 0;
  }

  .offcanvas-body {
    p,
    b {
      color:                            var(--Brand-Primary, #1B294A);
      font-size:                        var(--font-size-14);
      font-weight:                      300;
      line-height:                      140%; /* 19.6px */
      margin-bottom:                    26px;
    }

    .label-success {
      font-weight:                      600;
      text-transform:                   none !important;
      line-height:                      normal;
      padding:                          10px 15px;
    }

    b {
      font-weight:                      700;
      display:                          block;
      margin-top:                       15px;
    }
  }

  .offcanvas-footer {
    display:                            flex;
    flex-direction:                     column;
    gap:                                26px;

    .btn {
      font-size:                        var(--font-size-14);
      font-weight:                      700;
      line-height:                      normal;
      letter-spacing:                   4.2px;
      text-align:                       center;
      text-transform:                   uppercase;
      width:                            100%;
      padding:                          20px;
    }

    .btn-success {
      color:                            var(--Shades-W, #FFF);
    }
  }
}
</style>

<script>
import { inject } from "vue";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe("pk_test_51Oqcal06iKAIDsqJYwCAsFEsHMmh9p4aw3SIe3xq4TYtS4V2zbZfUH8uEskBHrFhCSrnBpD3vUZUlKtqg9XRT39I00VCqEpUtB");

export default {
  name: 'PlansCancelOffcanvas',
  props: ['offcanvas_id'],
  data: () => ({
    offcanvas_cancel: null,
    step: 0,
    locale: null,
    planInfo: {
      name: '',
      limit: '',
      start: '',
      end: ''
    }
  }),
  mounted() {
    this.locale = this.$i18n?.locale || 'en'
  },
  methods: {
    show(options = {}) {
      this.planInfo.name = options.planName || '---'
      this.planInfo.limit = options.planLimit || '0'
      this.planInfo.start = options.startDate || ''
      this.planInfo.end = options.endDate || ''
      this.step = 0

      this.offcanvas_cancel = new bootstrap.Offcanvas(document.getElementById(this.offcanvas_id)).show()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },

    doConfirm() {
      this.offcanvas_cancel = null;
      this.resolvePromise(true)
    },

    doCancel() {
      this.offcanvas_cancel = null;
      this.resolvePromise(false)
    },
    
    helpcenterUrl() {
      const url = this.locale == 'pt-br' 
        ? 'https://phelcom.com/pt-br/helpcenter/' 
        : 'https://phelcom.com/helpcenter/';
      
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      this.offcanvas_cancel = null;
      this.resolvePromise(false);
    }
  }
}
</script>
